import { render, staticRenderFns } from "./m-machine-pos.vue?vue&type=template&id=0dcd2c8e&scoped=true&"
import script from "./m-machine-pos.vue?vue&type=script&setup=true&lang=ts&"
export * from "./m-machine-pos.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./m-machine-pos.vue?vue&type=style&index=0&id=0dcd2c8e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dcd2c8e",
  null
  
)

export default component.exports